import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

const BrandColumn = inject("stores") (
    observer (
        class BrandColumn extends Component {
            constructor(props) {
                super(props);
                this.props = props;
                this.urlAPI = process.env.REACT_APP_URL_API;

                this.state = {

                }

                this.storeUi = this.props.stores.storeUi;
            }

            componentDidMount = () => {

            }

            render() {
                return (
                    this.props.data.map((data) => (
                        (data.type == 'text' || data.type == 'quote') &&
                            <div className={"block--brand__column-section block--brand__column-section--" + data.type}>
                                <p 
                                    dangerouslySetInnerHTML={{ __html: data.value}}
                                />   
                            </div> 
                    ))
                );
            }
        }
    )
)

export default BrandColumn;
